<div cdkScrollable class="wrapper overflow-y-auto d-flex flex-column flex-grow-1 p-2">
  <nav class="navbar justify-content-end" [class.moving]="isMoving">
    <div class="w-100 mb-1">
      <div class="input-group input-group-sm">
        <input
          type="text"
          class="form-control"
          placeholder="Zoeken..."
          [ngModel]="searchInput$.value"
          (ngModelChange)="searchInput$.next($event)"
        />
        @if (searchInput$.value) {
          <button
            class="btn btn-outline-secondary"
            type="button"
            (click)="searchInput$.next('')"
            title="Zoekterm wissen"
          >
            <i class="bi bi-x"></i>
          </button>
        }
      </div>
    </div>
    @if (
      canSelect &&
      !comparisonService.isComparingDates() &&
      !comparisonService.isLiveView() &&
      !isMultiSelectAlwaysEnabled
    ) {
      <div class="form-check form-switch flex-grow-1">
        <input
          class="form-check-input"
          type="checkbox"
          role="switch"
          id="flexSwitchCheckDefault"
          [(ngModel)]="isComparisonEnabled"
          (ngModelChange)="onSelectChange()"
        />
        <label class="form-check-label" for="flexSwitchCheckDefault">Vergelijken</label>
      </div>
    }
    <div class="d-flex">
      @if (canEdit) {
        <div
          class="me-3"
          tabindex="0"
          role="button"
          (click)="dragAndDropClicked(); isMovingTooltip.close()"
          (keypress)="dragAndDropClicked(); isMovingTooltip.close()"
          [ngbTooltip]="!isMoving ? 'Verplaatsen' : 'Klaar met verplaatsen'"
          #isMovingTooltip="ngbTooltip"
          style="cursor: pointer"
        >
          <i class="bi" [class]="isMoving ? 'bi-check-lg' : 'bi-arrows-move'"></i>
        </div>
      }
      @if (canFlow) {
        <div class="col">
          <div class="d-inline-block me-2" ngbTooltip="Hiërarchie op basis van zones">
            <i class="bi bi-buildings"></i>
          </div>
          <div class="form-check form-switch d-inline-block">
            <input
              class="form-check-input"
              type="checkbox"
              role="switch"
              id="site_meter"
              [(ngModel)]="isEnergyFlowActive"
              (ngModelChange)="onFlowChange()"
            />
            <div for="site_meter" class="form-check-label" ngbTooltip="Hiërarchie op basis van sub-meters">
              <i class="bi bi-diagram-3"></i>
            </div>
          </div>
        </div>
      }
    </div>
  </nav>
  <ng-container *ngTemplateOutlet="listItem; context: { $implicit: filteredMenuItems }"></ng-container>
  @if (hasNoAssets()) {
    <div class="text-muted text-center mt-3 px-3 small">
      <i class="bi bi-inbox fs-2"></i>
      <div>Er zijn geen geschikte assets beschikbaar voor deze weergave in de organisatie.</div>
    </div>
  }
  @if (!filteredMenuItems) {
    <ul class="placeholder-glow">
      <li>
        <div class="placeholder">​</div>
      </li>
      @for (i of [].constructor(3); track $index) {
        <ul>
          <li>
            <div class="placeholder">​</div>
          </li>
          <ul>
            @for (i of [].constructor(3); track $index) {
              <li>
                <div class="placeholder">​</div>
              </li>
            }
          </ul>
        </ul>
      }
    </ul>
  }
</div>

@if (canSelect && isComparisonEnabled) {
  <button
    [disabled]="!hasChanged || !(isComparisonEnabled && selectedItems.length >= minimumSelections)"
    class="save btn btn-primary p-2 rounded-0"
    (click)="onSave()"
  >
    Toepassen
    @if (isComparisonEnabled && minimumSelections > selectedItems.length) {
      <span>(Selecteer minimaal {{ minimumSelections }})</span>
    }
    @if (selectedItems.length >= maximumSelections) {
      <span>({{ maximumSelections }}/{{ maximumSelections }})</span>
    }
  </button>
}

<ng-template #listItem let-menuItems let-root="root">
  <ul
    cdkDropList
    cdkDropListSortingDisabled
    [cdkDropListDisabled]="!isMoving"
    (cdkDropListDropped)="drop($event)"
    cdkDropListAutoScrollStep="10"
    [class.compare]="isComparisonEnabled"
    [attr.menu-item-id]="root"
  >
    @for (item of menuItems; track $index) {
      @if (item.visible !== false) {
        <li
          [id]="item.id"
          cdkDrag
          [cdkDragData]="item"
          [cdkDragPreviewClass]="'menu-item-drag-preview'"
          [cdkDragDisabled]="!isMoving"
          (cdkDragStarted)="grab($event)"
          (cdkDragMoved)="move($event)"
          class="menu-item-container"
        >
          <div class="menu-item-content">
            <div>
              @if (canSelect && isComparisonEnabled) {
                <div class="form-check">
                  <input
                    [id]="'form-' + item.id"
                    class="form-check-input"
                    type="checkbox"
                    [(ngModel)]="item.selected"
                    [disabled]="!item.selectable"
                    (ngModelChange)="onSelectionChange(item)"
                  />
                </div>
              }
              @if (item.children.length > 0) {
                <button type="button" class="collapsible" (click)="collapse(item)">
                  @if (item.collapsed) {
                    <i class="bi bi-chevron-right"></i>
                  } @else {
                    <i class="bi bi-chevron-down"></i>
                  }
                </button>
              }
              @if (item.children.length === 0) {
                <i class="bi bi-chevron-right opacity-0"></i>
              }
              <label class="form-check-label" [for]="'form-' + item.id">
                @if ((canSelect || canEdit) && (isComparisonEnabled || isMoving)) {
                  <ngb-highlight
                    [result]="item.name"
                    [term]="(searchTerm$ | async)!"
                    [class.active]="isActive(item.queryParams)"
                  ></ngb-highlight>
                } @else {
                  <a
                    [routerLink]="[]"
                    [queryParams]="generateQueryParamsForMenuItem(item.queryParams)"
                    [class.active]="isActive(item.queryParams)"
                  >
                    <ngb-highlight [result]="item.name" [term]="(searchTerm$ | async)!"></ngb-highlight>
                  </a>
                }
                @if (item.subscriptionAccessSource === subscriptionAccessSource.InternalUse) {
                  <span class="subscription-access-badge ms-1">Intern gebruik</span>
                }
              </label>
            </div>
            @if (isMoving && invalidDropTargetId === item.id) {
              <i
                class="bi bi-x-circle-fill drop-not-allowed-indicator"
                ngbTooltip="Deze plek is niet toegestaan voor deze verplaatsing"
              ></i>
            }
            @if (shouldShowAddButton(item)) {
              <button
                type="button"
                class="add-item-btn btn btn-sm btn-outline-primary"
                [class.always-visible]="isActive(item.queryParams)"
                (click)="openCreateItemModal(item); $event.stopPropagation()"
              >
                <i class="bi bi-plus"></i>
              </button>
            }
          </div>
        </li>
        @if (item.children.length > 0 && !item.collapsed) {
          <ng-container
            *ngTemplateOutlet="listItem; context: { $implicit: item.children, root: item.id }"
          ></ng-container>
        }
      }
    }
  </ul>
</ng-template>
